export default __webpack_public_path__ + "static/media/shogun_004.82e8d871.jpg";